<template>
    <div class="md-input-container md-theme-default md-has-select md-has-value" :class="{'show-md-dark-mode': showMode}">
        <label :for="'active-user-' + slotNumber">Active User #{{slotNumber}}</label>
        <select class="affiliate-slot-select-box" :class="{'show-md-dark-mode': showMode}" v-model="affiliateUser" @change="changeSlotAffiliate" style="width: 100%; border: none; outline: none; font-size: 16px;">
            <option value="">Open License</option>
            <option v-for="usr in availableList" :value="usr.uid" :key="usr.uid">{{ usr.username }}</option>
        </select>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: ['slotNumber', 'slotAffiliate', 'affiliateUsers'],
    data: function() {
        return {
            affiliateUser: this.slotAffiliate || '',
            userList: []
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'users',
            'userByUID',
            'showMode'
        ]),
        availableList() {
            return this.userList.map(usr => ({
                uid: usr.uid,
                username: usr.username
            }));
        }
    },
    methods: {
        async loadUsers() {
            const uids = Object.keys(this.affiliateUsers || {});
            this.userList = await Promise.all(
                uids.map(async (uid) => {
                    const usr = await this.userByUID(uid);
                    if (!usr) {
                        return null;
                    }
                    // A member with their own subscription already has access, so
                    // giving them a seat spends one of the institution's licenses
                    // for nothing. They stay on the roster (shown as "Own
                    // subscription") but are not offered here.
                    if (usr.hasOwnSubscription) {
                        return null;
                    }
                    return { uid: usr.uid, username: usr.username };
                })
            );

            this.userList = this.userList.filter(u => u !== null);
        },
        changeSlotAffiliate() {
            if (this.slotAffiliate === this.affiliateUser) {
                return;
            }
            if (!this.slotAffiliate && this.affiliateUser) {
                this.affiliateUsers[this.affiliateUser] = true;
            }
            if (this.slotAffiliate && !this.affiliateUser) {
                this.affiliateUsers[this.slotAffiliate] = false;
            }
            if (this.slotAffiliate && this.affiliateUser) {
                this.affiliateUsers[this.slotAffiliate] = false;
                this.affiliateUsers[this.affiliateUser] = true;
            }
            this.$emit('updateSlot', {
                slotNumber: this.slotNumber,
                uid: this.affiliateUser
            });
        }
    },
    async created() {
        await this.loadUsers();
    },
    watch: {
        affiliateUsers: {
            handler: 'loadUsers',
            immediate: true
        }
    }
};
</script>

<style lang="scss">
.affiliate-slot-select-box.show-md-dark-mode {
    color: white;
    background: #424242;
}
</style>


// WEBPACK FOOTER //
// affiliate-slot.vue?12c0bd12